import type { AnsweringSubscriptionTag } from '@bb/domain/dist/types';
import { createFormatDateFunction } from 'utils';
import type { TagProps } from 'components';

export const addDatacy =
  (key: string) =>
  ({ id }: { id: string }) =>
    ({ 'data-cy': `${key}-${id}` }) as React.HTMLAttributes<HTMLElement>;

export const addDatacyToHeader = (key: string) => () =>
  ({ 'data-cy': `${key}-header` }) as React.HTMLAttributes<HTMLElement>;

export const getSubscriptionTagTextAndColor = (
  tag: AnsweringSubscriptionTag | 'LiveConciergePlus' | 'AppointmentDesk',
  hasValidStripeMlsProductId?: boolean,
) => {
  const result = {
    color: '',
    text: '',
  };
  switch (tag) {
    case 'on':
      result.color = 'green';
      result.text = 'On';
      break;
    case 'ns':
      result.color = 'red';
      result.text = hasValidStripeMlsProductId ? 'No Subscription' : 'N/S';
      break;
    case 'unc':
      result.color = 'red';
      result.text = 'Not BrokerBay';
      break;
    case 'LiveConciergePlus':
      result.color = 'green';
      result.text = 'Live Concierge';
      break;
    case 'AppointmentDesk':
      result.color = 'blue';
      result.text = 'Appt Desk Only';
      break;
    default:
      throw new Error(`Unknown tag name ${tag}`);
  }
  return result;
};

export const assume = (orgId: string) => {
  const chatSessionStorageKeys = [
    'messageDrafts',
    'messageDraftsForNewConvo',
    'chatInstances',
    'activeChatInstance',
    'newConvoSelections',
    'assumedChatInstances',
    'assumedBrokerageId',
  ];

  chatSessionStorageKeys.forEach(key => sessionStorage.removeItem(key));
  window.location.pathname = `/answering/assume/${orgId}`;
};

export const formatDateStr = createFormatDateFunction('MMM d, yyyy h:mmaaa');

export const getStatusTagColor = (
  status: 'ACTIVE' | 'ONBOARDING' | 'unclaimed' | 'UNCLAIMED',
): TagProps['color'] => {
  switch (status) {
    case 'ACTIVE':
      return 'green';
    case 'ONBOARDING':
      return 'blue';
    case 'unclaimed':
    case 'UNCLAIMED':
      return 'red';
    default:
  }
};
